"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ContentSt = require("./Content.st.css");

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Card/Content/Content.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Content = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Content, _React$Component);

  var _super = _createSuper(Content);

  function Content() {
    var _this;

    (0, _classCallCheck2["default"])(this, Content);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getChildName", function (children) {
      return children && children.type && (children.type.displayName || children.type.name);
    });
    return _this;
  }

  (0, _createClass2["default"])(Content, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          size = _this$props.size,
          dataHook = _this$props.dataHook;
      var isEmptyStateContent = this._getChildName(children) === 'EmptyState';
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-hook": dataHook,
        "data-size": size,
        className: (0, _ContentSt.st)(_ContentSt.classes.root, {
          size: size,
          emptyStateContent: isEmptyStateContent
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31,
          columnNumber: 7
        }
      }, children);
    }
  }]);
  return Content;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Content, "displayName", 'Card.Content');
(0, _defineProperty2["default"])(Content, "propTypes", {
  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook: _propTypes["default"].string,

  /** Accepts any component as a child element to display inside the card content area */
  children: _propTypes["default"].node,

  /** Controls paddings of the content area */
  size: _propTypes["default"].oneOf(['medium', 'large'])
});
(0, _defineProperty2["default"])(Content, "defaultProps", {
  size: 'medium'
});
var _default = Content;
exports["default"] = _default;
//# sourceMappingURL=Content.js.map